/* eslint-disable parog-web/no-glint-expect-error-directive */
import Component from '@glimmer/component';
import type { EmberChangeset } from 'ember-changeset';
import FormyField from './field';
import FormyComponent from '../formy';
import FuiCheckbox from 'parog-web/components/fui-checkbox';
import { hash } from '@ember/helper';
import changesetSet from 'ember-changeset/helpers/changeset-set';
import changesetGet from 'ember-changeset/helpers/changeset-get';

type Args =
  | { parent: FormyComponent; key: string }
  | {
      parent: FormyField;
      key: never;
    };

interface Signature {
  Args: Args;
}

interface Signature {
  Args: Args;
}

export default class FormyCheckboxComponent extends Component<Signature> {
  get changeset(): EmberChangeset {
    return this.#formy.args.changeset;
  }

  get key(): string {
    return this.args.parent instanceof FormyField
      ? this.args.parent.args.key
      : this.args.key;
  }

  get #formy(): FormyComponent {
    if (this.args.parent instanceof FormyComponent) return this.args.parent;
    return this.args.parent.args.formy;
  }

  <template>
    <FuiCheckbox
      @settings={{hash onChange=(changesetSet this.changeset this.key)}}
      {{! @glint-expect-error }}
      @label={{@label}}
      @isChecked={{changesetGet this.changeset this.key}}
      {{! @glint-expect-error }}
      @type={{@type}}
    />
  </template>
}
